import PropTypes from "prop-types";

const propTypes = {
  variant: PropTypes.oneOf(["default", "outline"]),
  color: PropTypes.string,
  size: PropTypes.number
};

const defaultProps = {
  variant: "default",
  color: "#000",
  size: 24
};

export default Object.assign({}, { propTypes, defaultProps });
